<template>
  <div class="row mt-4" :class="{ 'service-inactive': !service.active }">
    <!-- with credential -->
    <template v-if="withCredential(service)">
      <div class="col-md-1">
        <input v-model="service.enable" type="checkbox">
      </div>

      <div class="col-md-5">
        <span>{{ service.friendlyName }}</span>
      </div>

      <div class="col-md-6">
        <select v-model="service.credentialId" class="form-control">
          <option :value="null"> - </option>
          <option
            v-for="credential in credentialByService(service)"
            :key="credential.id"
            :value="credential.id"
            :title="credential.description"
          >
            {{ credential.nickname }}
          </option>
        </select>
      </div>
    </template>

    <!-- without credential -->
    <template v-else>
      <div class="col-md-1">
        <input v-model="service.enable" type="checkbox">
      </div>

      <div class="col-md-5">
        <span>{{ service.friendlyName }}</span>
      </div>
    </template>
  </div>
</template>

<script>

const credentialFields = ['login', 'cnpj', 'cpf', 'cpf_cnpj', 'password']

const govbrServiceName = 'govbr'
const govbrIdentifiers = [
  'dnit', 'der_sp',
  'detran_ba', 'detran_df', 'detran_es', 'detran_go',
  'detran_mg', 'detran_pe', 'detran_pr', 'detran_rn',
  'detran_rs', 'detran_sc',
  'sne_denatran', 'sefaz_sp', 'sefaz_rs'
]

const isGovbrScraper = (serviceName) => govbrIdentifiers.some(id => serviceName.includes(id))

export default {
  methods: {
    withCredential(service) {
      return Array.isArray(service.validateFields) &&
             service.validateFields.some(field => credentialFields.includes(field))
    },
    credentialByService() {
      return this.credentials.filter(c => {
        if (c.serviceName === this.service.name) return true
        if (c.serviceName === govbrServiceName && isGovbrScraper(this.service.name)) return true
        return false
      })
    },
  },
  name: 'Service',
  props: {
    credentials: {
      required: true,
      type: Array
    },
    service: {
      required: true,
      type: Object
    }
  },
}
</script>

<style scoped>
.service-inactive {
  opacity: 0.5;
  color: #999;
}
</style>